/// <amd-module name="TFS/CreateProject/Components/StatusMessageCard" />
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import * as React from "react";
import { StatusMessageType } from "TFS/CreateProject/Contracts";
import { IStatusMessage } from "TFS/CreateProject/Models";
import { VssComponent } from "VSS/Platform/Layout";

export interface IStatusMessageCardProps {
    statusMessage: IStatusMessage;
}

export class StatusMessageCard extends VssComponent<IStatusMessageCardProps, {}> {
    public render(): JSX.Element | null {
        const { statusMessage } = this.props;
        const statusMessageType = statusMessage.statusMessageType;
        const projectCreationInProgress = statusMessageType === StatusMessageType.Waiting;
        const showMessage = statusMessageType !== StatusMessageType.NoStatus;

        return showMessage ? (
            <div className="status-message-container">
                {!projectCreationInProgress && (
                    <MessageCard severity={MessageCardSeverity.Error}>{statusMessage.message}</MessageCard>
                )}
            </div>
        ) : null;
    }
}
